import { handleApi } from "./common";

const API_CONSTANTS = {
  authVerification: (data) =>
    `/api/iam/auth/check?contact_type=${data.contactType}&contact_value=${data.contactValue}`,
  generateOtp: "/api/communication/send/otp",
  resendOtp: (otp_id) => `api/communication/resend/otp/${otp_id}`,
  verifyOtp: (otpId, otp) => `/api/communication/verify/otp/${otpId}?otp=${otp}`,
  updateBank: "/api/partner/user/updatebank",
  applyReferralCode: (code) => `api/referral/apply?code=${code}`,
  portfolio: `api/invest/reportv4/portfolio/min-summary`,
  npsInvestmentStatus: "/api/nps/invest/status/v2",
};

export const hitCampaignFeedbackUrl = async (Api, url) => {
  const res = await Api.get(url);
  return handleApi(res);
};

export const authVerification = async (Api, data, token) => {
  const res = await Api.get(
    API_CONSTANTS.authVerification(data),
    {},
    {},
    token
  );
  return handleApi(res);
};

export const generateOtp = async (Api, data, token) => {
  const res = await Api.post(API_CONSTANTS.generateOtp, data, {}, token);
  return handleApi(res);
};

export const resendOtp = async (Api, data, token) => {
  const { otpId, ...rest } = data;
  const res = await Api.post(API_CONSTANTS.resendOtp(otpId), rest, {}, token);
  return handleApi(res);
};

export const verifyOtp = async (Api, data, token) => {
  const { otpId, otp, ...rest } = data; 
  const res = await Api.post(API_CONSTANTS.verifyOtp(otpId, otp), rest, {}, token);
  return handleApi(res);
};

export const applyReferralCode = async (Api, code, token) => {
  const res = await Api.get(
    API_CONSTANTS.applyReferralCode(code),
    {},
    {},
    token
  );
  return handleApi(res);
};

export const getPortfolioData = async (Api, token) => {
  const res = await Api.get(API_CONSTANTS.portfolio, {}, {}, token);
  return handleApi(res);
};

export const getNPSInvestmentStatus = async (Api, token) => {
  const res = await Api.get(API_CONSTANTS.npsInvestmentStatus, {}, {}, token);
  return handleApi(res);
};

export const update_banklist = async (Api, data, token) => {
  const res = await Api.post(API_CONSTANTS.updateBank, data, {}, token);
  return handleApi(res);
};